module.exports = __webpack_public_path__ + "img/publish.ed3dbaf8.png";